module.exports = __webpack_public_path__ + "static/media/scorekeeping.7ee73de2.png";